/**
 * Mock data para usuarios internos de OWLY
 */

import { UserRole } from '@/shared/types/sgi-roles.types';
import {
  OwlyUser,
  OwlyUserStatus,
  OwlyDepartment,
  OwlyTeamSummary,
} from '../entities/owly-user';

export const MOCK_OWLY_USERS: OwlyUser[] = [
  {
    id: 'owly-001',
    name: 'Pablo Gonzalez',
    email: 'pablo.gonzalez@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=12',
    role: UserRole.OWLY_ADMIN,
    jobTitle: 'CEO',
    department: OwlyDepartment.MANAGEMENT,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2023-01-10',
    phone: '+56 9 8765 4321',
    metrics: {
      assignedCompanies: 1,
      lastLogin: '2025-10-08T10:45:00Z',
    },
    specialPermissions: ['system:full_access', 'billing:manage_all'],
    internalNotes: 'CEO y fundador. Acceso total al sistema.',
  },
  {
    id: 'owly-003',
    name: 'Juan Numpaque',
    email: 'juan.numpaque@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=33',
    role: UserRole.OWLY_SUPPORT,
    jobTitle: 'Product Manager',
    department: OwlyDepartment.MANAGEMENT,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2023-05-20',
    phone: '+56 9 6543 2109',
    metrics: {
      assignedCompanies: 0,
      lastLogin: '2025-10-08T10:15:00Z',
    },
    internalNotes: 'Product Manager. Define roadmap y estrategia de producto.',
  },
  {
    id: 'owly-005',
    name: 'Nicolas Ayala',
    email: 'nicolas.ayala@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=68',
    role: UserRole.OWLY_DEV,
    jobTitle: 'Frontend Developer',
    department: OwlyDepartment.DEVELOPMENT,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2023-06-15',
    phone: '+56 9 4321 0987',
    metrics: {
      assignedCompanies: 0,
      lastLogin: '2025-10-08T09:50:00Z',
    },
    specialPermissions: ['development:frontend'],
    internalNotes: 'Frontend Developer. Especialista en UI/UX.',
  },
  {
    id: 'owly-006',
    name: 'Andres Martinez',
    email: 'andres.martinez@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=32',
    role: UserRole.OWLY_SALES,
    jobTitle: 'Customer Success Manager',
    department: OwlyDepartment.SALES,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2024-01-08',
    phone: '+56 9 3210 9876',
    metrics: {
      assignedCompanies: 2,
      lastLogin: '2025-10-08T10:00:00Z',
    },
    internalNotes: 'Customer Success Manager. Retención y éxito del cliente.',
  },
  {
    id: 'owly-007',
    name: 'Natalia Sanchez',
    email: 'natalia.sanchez@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=15',
    role: UserRole.OWLY_SALES,
    jobTitle: 'Marketing Manager',
    department: OwlyDepartment.SALES,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2024-03-12',
    phone: '+56 9 2109 8765',
    metrics: {
      assignedCompanies: 0,
      lastLogin: '2025-10-08T09:45:00Z',
    },
    internalNotes: 'Marketing Manager. Estrategia de adquisición y brand awareness.',
  },
  {
    id: 'owly-008',
    name: 'Camilo Quintero',
    email: 'camilo.quintero@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=44',
    role: UserRole.OWLY_DEV,
    jobTitle: 'Backend Developer',
    department: OwlyDepartment.DEVELOPMENT,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2023-04-20',
    phone: '+56 9 1098 7654',
    metrics: {
      assignedCompanies: 0,
      lastLogin: '2025-10-08T08:00:00Z',
    },
    specialPermissions: ['system:logs', 'development:backend'],
    internalNotes: 'Backend Developer. Especialista en APIs y microservicios.',
  },
  {
    id: 'owly-009',
    name: 'Santiago Serna',
    email: 'santiago.serna@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=52',
    role: UserRole.OWLY_SUPER_ADMIN,
    jobTitle: 'CTO',
    department: OwlyDepartment.MANAGEMENT,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2023-01-10',
    phone: '+56 9 9876 5432',
    metrics: {
      assignedCompanies: 0,
      lastLogin: '2025-10-08T11:00:00Z',
    },
    specialPermissions: ['*'],
    internalNotes: 'CTO y cofundador. Acceso técnico completo.',
  },
  {
    id: 'owly-012',
    name: 'Manuela Gamboa',
    email: 'manuela.gamboa@owly.cl',
    avatar: 'https://i.pravatar.cc/150?img=26',
    role: UserRole.OWLY_FINANCE,
    jobTitle: 'CFO',
    department: OwlyDepartment.MANAGEMENT,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2023-02-15',
    phone: '+56 9 5555 1234',
    metrics: {
      assignedCompanies: 0,
      lastLogin: '2025-10-08T08:30:00Z',
    },
    specialPermissions: ['billing:manage_all', 'analytics:financial'],
    internalNotes: 'CFO. Gestión financiera, facturación y análisis de revenue.',
  },
  {
    id: 'owly-ai-001',
    name: 'OWLY AI Agent',
    email: 'ai.agent@owly.cl',
    avatar: 'https://api.dicebear.com/7.x/bottts/svg?seed=owly-ai',
    role: UserRole.OWLY_CUSTOMER_SUCCESS,
    jobTitle: 'AI Customer Success Agent',
    department: OwlyDepartment.SUPPORT,
    status: OwlyUserStatus.ACTIVE,
    joinedAt: '2025-01-01',
    phone: '+56 9 AI AGENT',
    metrics: {
      assignedCompanies: 15,
      resolvedTickets: 328,
      avgResponseTime: '30 sec',
      lastLogin: '2025-10-08T11:30:00Z',
    },
    specialPermissions: ['ai:automated_responses', 'support:24/7'],
    internalNotes: 'AI Agent para Customer Success. Respuestas automáticas, onboarding y retención de clientes.',
  },
];

export const MOCK_OWLY_TEAM_SUMMARY: OwlyTeamSummary = {
  total: 9,
  active: 9,
  byDepartment: {
    [OwlyDepartment.SALES]: 2,
    [OwlyDepartment.SUPPORT]: 1,
    [OwlyDepartment.DEVELOPMENT]: 2,
    [OwlyDepartment.ANALYTICS]: 0,
    [OwlyDepartment.OPERATIONS]: 0,
    [OwlyDepartment.MANAGEMENT]: 4,
  },
  byRole: {
    [UserRole.OWLY_SUPER_ADMIN]: 1,
    [UserRole.OWLY_ADMIN]: 1,
    [UserRole.OWLY_SALES]: 2,
    [UserRole.OWLY_SUPPORT]: 1,
    [UserRole.OWLY_DEV]: 2,
    [UserRole.OWLY_ANALYST]: 0,
    [UserRole.OWLY_FINANCE]: 1,
    [UserRole.OWLY_CUSTOMER_SUCCESS]: 1,
  },
};

/**
 * Helper para obtener un usuario OWLY por ID
 */
export function getOwlyUserById(id: string): OwlyUser | undefined {
  return MOCK_OWLY_USERS.find((user) => user.id === id);
}

/**
 * Helper para obtener usuarios OWLY por rol
 */
export function getOwlyUsersByRole(role: UserRole): OwlyUser[] {
  return MOCK_OWLY_USERS.filter((user) => user.role === role);
}

/**
 * Helper para obtener usuarios OWLY por departamento
 */
export function getOwlyUsersByDepartment(department: OwlyDepartment): OwlyUser[] {
  return MOCK_OWLY_USERS.filter((user) => user.department === department);
}

/**
 * Helper para obtener usuarios OWLY activos
 */
export function getActiveOwlyUsers(): OwlyUser[] {
  return MOCK_OWLY_USERS.filter((user) => user.status === OwlyUserStatus.ACTIVE);
}
